import { useEffect } from "react";
import cookies from "js-cookie";

import { useAppDispatch } from "@hooks/store";
import { ACCESS_TOKEN } from "@constants/common";
import { checkIsLoggedIn } from "@store/thunks/user";

export const useTokenCheck = () => {
  const token = cookies.get(ACCESS_TOKEN);

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (token) dispatch(checkIsLoggedIn());
  }, [token]);
};
